<template>
    <confirm-dialog v-model="shows" v-bind="{ title, loading }" hideActions>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <template v-if="loading">
            <v-layout justify-center align-center>
                <v-progress-circular indeterminate size="100" width="5" color="primary" />
            </v-layout>
        </template>
        <template v-else-if="0 < ranks.length">
            <v-divider />
            <v-layout column class="px-20 py-16" style="gap: 8px">
                <template v-for="(item, index) in ranks">
                    <v-row :key="`${item._id}-data`" justify="space-between" no-gutters>
                        <v-col cols="auto"> {{ item.employer.info.name }} </v-col>
                        <v-col cols="auto"> {{ item.count.format() }}건 </v-col>
                    </v-row>
                    <v-divider :key="`${item._id}-line`" v-if="ranks.length - 1 != index" />
                </template>
            </v-layout>
            <v-divider />
        </template>
        <template v-else>
            <v-layout justify-center align-center>
                <span class="page-text"> 데이터가 없습니다 </span>
            </v-layout>
        </template>
    </confirm-dialog>
</template>

<script>
import api from "@/api";

import ConfirmDialog from "@/components/dumb/confirm-dialog.vue";

export default {
    components: {
        ConfirmDialog,
    },
    props: {
        _program: { type: String, default: null },

        title: { type: String, default: null },
        mode: { type: String, default: null },
        skip: { type: Number, default: 0 },
        limit: { type: Number, default: 5 },
    },
    data: () => ({
        ranks: [],

        shows: false,
        loading: false,
    }),
    methods: {
        init() {
            this.ranks = [];
            this.search();
        },
        async search() {
            if (!this.shows) return;
            if (!this._program) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                const { _program: _id, mode, skip, limit } = this;
                const { ranks } = await api.v1.expo.programs.getRanks({
                    _id,
                    headers: {
                        mode,
                        skip,
                        limit,
                    },
                });

                this.ranks = ranks;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
    watch: {
        _program() {
            this.init();
        },
        mode() {
            this.init();
        },
        skip() {
            this.init();
        },
        limit() {
            this.init();
        },
        shows() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>